export const StatusKey = {
	All:'all',
	SetupNotCompleted:'notcompleted',
	PendingApproval:'pendingapproval',
	UpcomingEvent:'upcoming',
	PendingPost:'pendingpost',
  Completed: 'completed',
  Canceled: 'canceled',
	RulesDenied: 'rulesdenied',
  RulesApproved: 'rulesapproved'
};
export const StatusDescription = {
  RulesDenied: 'Rules Denied',
  RulesApproved: 'Rules Approved',
  UpcomingEvent: 'Upcoming Events',
  Completed: 'Completed',
  Canceled: 'Canceled',
  SetupNotCompleted: 'Setup Not Complete',
  PendingApproval: 'Pending Approval',
  PendingPost: 'Pending Post Event Report'
};
export default [
	{
		id:1,
		key: StatusKey.SetupNotCompleted,
		description: StatusDescription.SetupNotCompleted,
	},
	{
		id:2,
		key:StatusKey.PendingApproval,
		description:StatusDescription.PendingApproval,
	},
  {
    id:3,
    key:StatusKey.RulesDenied,
    description:StatusDescription.RulesDenied,
  },
  {
    id:4,
    key:StatusKey.RulesApproved,
    description:StatusDescription.RulesApproved,
  },
	{
		id:5,
		key:StatusKey.UpcomingEvent,
		description:StatusDescription.UpcomingEvent,
	},
	{
		id:6,
		key:StatusKey.PendingPost,
		description:StatusDescription.PendingPost,
	},
	{
		id:7,
		key:StatusKey.Completed,
		description:StatusDescription.Completed,
  },
  {
    id: 8,
    key: StatusKey.Canceled,
    description:StatusDescription.Canceled,
  }
];




// WEBPACK FOOTER //
// ./src/utils/constants/eventstatus.js